module.exports = __webpack_public_path__ + "img/80.1f0b44d6.png";